import request from '@/utils/request'

const getOrderById = (id) => {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/order/${id}`,
    method: 'get'
  })
}

const getOrderByOrderNo = (orderNo) => {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/order/by-order-no`,
    method: 'get',
    params: { orderNo }
  })
}

const getOrderPageList = (query) => {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/order/page-list`,
    method: 'get',
    params: query
  })
}

function createOrder(data) {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/order`,
    method: 'post',
    data
  })
}

const updateOrder = (id, data) => {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/order/${id}`,
    method: 'put',
    data
  })
}

const cancelOrder = (id) => {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/order/${id}/cancel-order`,
    method: 'post',
  })
}

function checkOrderBeforePay(data) {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/order/check-order-before-pay`,
    method: 'post',
    data
  })
}


export default {
  createOrder,
  updateOrder,
  cancelOrder,
  getOrderById,
  getOrderPageList,
  getOrderByOrderNo,
  checkOrderBeforePay
}
